import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Grid,
  Paper,
  Divider,
} from '@mui/material';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import emailjs from "@emailjs/browser"; // ✅ nouvelle version du SDK

function Contact() {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [itinerary, setItinerary] = useState({
    start: '',
    end: 'SPEEDY TL, 7C76+RMJ, Rue Ghandi‬‎, Kénitra',
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });
  const handleItineraryChange = (e) =>
    setItinerary({ ...itinerary, [e.target.name]: e.target.value });

  // ✅ Nouvelle fonction d’envoi via EmailJS
  const handleSubmit = async (e) => {
  e.preventDefault();

  // 🕒 Créer une date lisible automatiquement
 const currentTime = new Date().toLocaleString("fr-FR", {
  timeZone: "Africa/Casablanca",
  dateStyle: "short",
  timeStyle: "short",
});

  try {
    const result = await emailjs.send(
      "service_4y5aolh",
      "template_xims5go",
      {
        name: form.name,
        email: form.email,
        message: form.message,
        time: currentTime, // ✅ on ajoute la date ici
      },
      "6gPwxKo8o9fZ40Fdr"
    );

    console.log(result.text);
    alert(t("contact.messageSent"));
    setForm({ name: "", email: "", message: "" });
  } catch (error) {
    console.error("Erreur:", error);
    alert(t("contact.error"));
  }
};


  const handleGetDirections = () => {
    if (itinerary.start) {
      const url = `https://www.google.com/maps/dir/${encodeURIComponent(
        itinerary.start
      )}/${encodeURIComponent(itinerary.end)}`;
      window.open(url, '_blank');
    } else {
      alert(t('contact.enterStartAddress'));
    }
  };

  return (
    <>
      <Helmet>
        <title>SPEEDY Transport & Logistics</title>
      </Helmet>

      <Box
        sx={{
          background: 'linear-gradient(180deg,  #35E3C8,#29C6D9)',
          py: 8,
          minHeight: '100vh',
        }}
      >
        <Container maxWidth={false} sx={{ my: 4, px: { xs: 2, md: 12 } }}>
          {/* === TITRE ANIMÉ === */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          >
            <Typography
              variant="h3"
              gutterBottom
              sx={{
                textAlign: 'center',
                fontWeight: 800,
                mb: 8,
                color: '#1e1e1e',
                textTransform: 'uppercase',
                fontFamily: "'Poppins', sans-serif",
                letterSpacing: '1px',
              }}
            >
              {t('contact.title')}
            </Typography>
          </motion.div>

          <Grid container spacing={5} alignItems="stretch">
            {/* === BLOC GAUCHE === */}
            <Grid sx={{ width: { xs: '100%', md: '70%' } }}>
              <Paper elevation={6} sx={{ p: 4, borderRadius: 4, backgroundColor: 'white' }}>
                <Typography variant="h5" sx={{ fontWeight: 900, color: '#007B8F', mb: 2 }}>
                  {t('contact.contactTitle')}
                </Typography>
                <Typography variant="body1" sx={{ color: '#333', mb: 2 }}>
                  {t('contact.address')}
                </Typography>
                <Typography variant="body1" sx={{ color: '#333', mb: 2 }}>
                  📞 +212 537 37 14 61
                </Typography>
                <Typography variant="body1" sx={{ color: '#333', mb: 2 }}>
                  📱 +212 661 51 92 91
                </Typography>
                <Typography variant="body1" sx={{ color: '#333' }}>
                  ✉️ contact@speedytl.com
                </Typography>

                <Divider sx={{ my: 3 }} />

                <Typography variant="h6" sx={{ fontWeight: 700, color: '#007B8F', mb: 2 }}>
                  {t('contact.itinerary')}
                </Typography>
                <TextField
                  label={t('contact.startAddress')}
                  name="start"
                  value={itinerary.start}
                  onChange={handleItineraryChange}
                  fullWidth
                  sx={{ mb: 2 }}
                />
                <Button
                  variant="outlined"
                  onClick={handleGetDirections}
                  sx={{
                    borderColor: '#00C2D1',
                    color: '#00C2D1',
                    '&:hover': { backgroundColor: '#00C2D1', color: 'white' },
                  }}
                  fullWidth
                >
                  {t('contact.getDirections')}
                </Button>

                <Box sx={{ mt: 3, borderRadius: 3, overflow: 'hidden', height: 400 }}>
                  <iframe
                    title="SPEEDY TL Map"
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3297.3709081582588!2d-6.590939623815848!3d34.26459280648719!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xda759006d82e5e5%3A0xde056b5a5bbbb945!2sSPEEDY%20TL!5e0!3m2!1sfr!2sma!4v1762467541949!5m2!1sfr!2sma"
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                  ></iframe>
                </Box>
              </Paper>
            </Grid>

            {/* === BLOC DROIT === */}
            <Grid sx={{ width: { xs: '100%', md: '27%' } }}>
              <Paper
                elevation={6}
                sx={{
                  p: 4,
                  borderRadius: 4,
                  backgroundColor: 'white',
                  height: '100%',
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    color: '#007B8F',
                    mb: 3,
                    fontFamily: "'Poppins', sans-serif",
                    textAlign: 'center',
                  }}
                >
                  {t('contact.formTitle')}
                </Typography>

                <Box
                  component="form"
                  onSubmit={handleSubmit}
                  sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
                >
                  <TextField
                    label={t('contact.name')}
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  <TextField
                    label={t('contact.email')}
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  <TextField
                    label={t('contact.message')}
                    name="message"
                    multiline
                    rows={4}
                    value={form.message}
                    onChange={handleChange}
                    required
                    fullWidth
                  />
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{
                      backgroundColor: '#00C2D1',
                      fontWeight: 600,
                      py: 1.2,
                      '&:hover': { backgroundColor: '#009bab' },
                    }}
                  >
                    {t('contact.send')}
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}

export default Contact;
